/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var PromotedJobBudget;
(function (PromotedJobBudget) {
    let interval;
    (function (interval) {
        interval["DAILY"] = "DAILY";
        interval["WEEKLY"] = "WEEKLY";
        interval["MONTHLY"] = "MONTHLY";
    })(interval = PromotedJobBudget.interval || (PromotedJobBudget.interval = {}));
})(PromotedJobBudget || (PromotedJobBudget = {}));
